import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import Text from '../Text/Text';
import alertIcon from './assets/error-alert-icon.png';
/**
 * Textarea component
 */

var StyledInput = styled.textarea.withConfig({
  displayName: "TextArea__StyledInput",
  componentId: "sc-8tw0zq-0"
})(["box-sizing:border-box;width:100%;margin:10px 0;min-height:65px;padding:6px 12px;font-size:", ";background-color:", ";border:1px solid;border-radius:0;border-color:", ";box-shadow:none;appearance:none;color:", ";:focus{border:1px solid ", ";}:focus::-webkit-input-placeholder{color:transparent;color:$color;font-size:$font-size;opacity:1;overflow:visible;}:focus:-moz-placeholder{color:transparent;color:$color;font-size:$font-size;opacity:1;overflow:visible;}:focus::-moz-placeholder{color:transparent;color:$color;font-size:$font-size;opacity:1;overflow:visible;}:focus:-ms-input-placeholder{color:transparent;color:$color;font-size:$font-size;opacity:1;overflow:visible;}@media ", "{max-width:100%;height:96px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize('m');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color('white');
}, function (_ref3) {
  var theme = _ref3.theme,
      error = _ref3.error;
  return !error ? theme.color('black') : theme.color('red');
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.color('black');
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.color('grey_for_forms');
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoint('small');
});
/**
 * Label component
 */

var Label = styled.label.attrs(function (_ref7) {
  var id = _ref7.id;
  return {
    htmlFor: "".concat(id)
  };
}).withConfig({
  displayName: "TextArea__Label",
  componentId: "sc-8tw0zq-1"
})(["display:flex;flex-direction:column;"]);
/**
 * Text error component
 */

var ErrorText = styled(Text).withConfig({
  displayName: "TextArea__ErrorText",
  componentId: "sc-8tw0zq-2"
})(["color:red;font-weight:", ";:before{position:relative;content:'';display:inline-block;top:2px;vertical-align:middle;margin-right:6px;background:url(", ") left 0/100% no-repeat;width:18px;height:19px;display:inline-block;vertical-align:top;color:", ";}"], function (_ref8) {
  var weight = _ref8.weight;
  return weight;
}, alertIcon, function (_ref9) {
  var theme = _ref9.theme;
  return theme.color('red');
});

var TextArea = function TextArea(_ref10) {
  var id = _ref10.id,
      label = _ref10.label,
      errorMsg = _ref10.errorMsg,
      rest = _objectWithoutProperties(_ref10, ["id", "label", "errorMsg"]);

  var error = errorMsg && errorMsg.length > 0;
  return React.createElement(Label, null, React.createElement(Text, {
    weight: "bold"
  }, label), React.createElement(StyledInput, Object.assign({}, rest, {
    error: error ? 1 : 0,
    "aria-describedby": id
  })), error && React.createElement(ErrorText, {
    size: "sm"
  }, errorMsg));
};

export default TextArea;